define('views/map/name_infowindowcontent',[
    "backbone",
    "text!views/map/name_infowindow.html",
    "views/_base/baseview"
], function (Backbone, Template, BaseView) {
    "use strict";

    return BaseView.extend({
        template   : _.template(Template),
        tagName    : 'div',
        className  : 'map-info-window',
        isRender   : true,
        needsAuth  : false,
        scrollToTop: false,
        events     : {},
        initialize: function(options) {
            this.GUID = options.GUID;
            this.MGUID = options.MGUID || options.MerchantGroupGUID;
            this.AGUID = options.AGUID;
            this.name = options.name;
            this.imgURL = options.imgURL;
            this.address = options.address;
            this.distance = (options.distance != 'NaN') ? options.distance+' mi' : '';
            this.rebate = options.rebate;
            this.data = options;
            BaseView.prototype.initialize(this);
        },

        render: function() {
            var that = this;
            this.$el.html(this.template({ data: this.data }));
            // TODO: Get away from using a timeout
            setTimeout(function(){
                $('.map-info-window').on('click',function(){
                    that.showMerchantDetails(that);
                });
            },300);
            return this;
        },

        showMerchantDetails: function(iw){
            pf.navigate('#merchants/groups/'+iw.MGUID+'/info/'+iw.GUID);
        }

    });
});
